// extracted by css-extract-rspack-plugin
export default {"noScroll":"_f93cd3a5"};